import ConfirmPasswordForm from '@features/signup/confirm-password-form/confirm-password-form';
export default ConfirmPasswordForm;
